<template>
  <div
    class="w-full inline-flex flex-col items-center border-t-2 border-gray-300 dark:border-transparent rounded-lg overflow-y-scroll"
    style="min-height: auto; max-height: 300px;"
  >
    <h2 class="text-2xl my-2 text-gray-800 dark:text-white">
      Dernières recherches :
    </h2>
    <ul class="inline-flex flex-col w-3/4 h-auto">
      <li
        v-for="(i, k) in $store.state.lastSearch.slice().reverse()"
        @click="select(i)"
        :key="i.ligne + i.stations[0]"
      >
        <LigneStation
          class="m-2"
          :ligne="i.ligne"
          :station="i.stations[0]"
          :direction="''"
          :next="''"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import LigneStation from "@/components/LigneStation";

export default {
  name: "HomeSearchHilight",
  components: {
    LigneStation
  },
  methods: {
    select(station) {
      if (this.$store.state.selected != station) {
        console.log("Select home");
        console.log(station);
        this.$store.commit("select", station);
        this.$store.dispatch("call");
        this.$store.commit("search", "");
      }
    }
  }
};
</script>
